<template>
  <div class="contract">
    <Banner :list="banners"></Banner>
    <div class="contract-main container">
      <passage></passage>
      <div class="serve">
        <div class="main-title">
          <h1>总承包资质服务</h1>
          <h3>业务范围覆盖全国 7*24小时无忧服务</h3>
        </div>
        <div class="list">
          <template v-for="(item, index) in childList">
            <div class="item mb-3" :key="index" @click="navView(item.skip_url)">
              <div class="img-box">
                <img :src="item.image_url" alt="" />
              </div>
              <p class="name mt-1">{{ item.name }}</p>
            </div>
          </template>
        </div>
      </div>
      <connect></connect>
    </div>
    <div class="required">
      <div class="main-title">
        <h1>办理资质所需材料</h1>
      </div>
      <div class="list">
        <img src="@/assets/image/design/step.jpg" alt="" />
      </div>
      <div class="m-list">
        <div class="item">
          <img src="@/assets/image/project/213.png" alt="" />
          <div class="info">
            <h3 class="title">企业复印件</h3>
            <p class="desc">
              企业营业执照正本，副本彩色扫描件 法人代表身
              份证（正反面）彩色复印件 企业章程（含变更） 彩色扫描件
            </p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/image/project/214.png" alt="" />
          <div class="info">
            <h3 class="title">办公场所证明</h3>
            <p class="desc">
              属于自有产权，房屋产权彩色扫描件 属于租赁，
              房屋租赁合同、使用证明及房产证彩色扫描件
            </p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/image/project/215.png" alt="" />
          <div class="info">
            <h3 class="title">人员资料</h3>
            <p class="desc">
              技术工人身份证彩色扫描件 技术负责人（或注册建 造师）基本情况及业绩
              技术负责人身份证明、职业 资格证书或技能证书
            </p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/image/project/216.png" alt="" />
          <div class="info">
            <h3 class="title">其他资料</h3>
            <p class="desc">
              标准要求的主要设备购置发票 经省级注册管理部
              门批准的注册建造师初始注册或变更 注册材料（ 新企业无资质）
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="contract-main container">
      <div class="questions-contract">
        <div class="main-title">
          <h1>常见问题</h1>
        </div>
        <div class="questions-contract-main">
          <div class="list">
            <template v-for="(item, index) in questions">
              <div class="item" :key="index">
                <h3 class="title pl-2">{{ item.name }}</h3>
                <div class="answer px-2 py-3">
                  <p :title="item.answer">{{ item.answer }}</p>
                </div>
              </div>
            </template>
          </div>
          <div class="m-list">
            <a-collapse default-active-key="1" :bordered="false" accordion>
              <template #expandIcon="props">
                <div class="icon"></div>
              </template>
              <template v-for="(item, index) in questions">
                <a-collapse-panel :key="index" :header="item.name">
                  <p class="desc">{{ item.answer }}</p>
                </a-collapse-panel>
              </template>
            </a-collapse>
          </div>
          <div class="btns">
            <a-button
              class="wow pulse"
              data-wow-delay="300ms"
              data-wow-iteration="infinite"
              data-wow-duration="2s"
              type="primary"
              @click="$toConnectLink"
            >
              在线咨询
            </a-button>
            <a-button
              class="wow pulse"
              data-wow-delay="300ms"
              data-wow-iteration="infinite"
              data-wow-duration="2s"
              @click="$toConnectLink"
              >了解更多</a-button
            >
          </div>
        </div>
      </div>
      <choose></choose>
      <div class="strength">
        <div class="main-title">
          <h1>客户见证</h1>
          <h3>10万+建企的共同选择，最贴心的资质咨询管家</h3>
        </div>
        <div class="strength-main">
          <div
            class="strength-left"
            :style="
              'backgroundImage:url(' +
              require('@/assets/image/contract/49.jpg') +
              ')'
            "
          >
            <img src="@/assets/image/contract/49.jpg" alt="" />
          </div>
          <div class="strength-contract pl-5">
            <div class="swiper-container strength-container">
              <div class="swiper-wrapper">
                <template v-for="(item, index) in comments">
                  <div class="swiper-slide strength-slide" :key="index">
                    <img :src="item.icon" alt="" />
                    <div class="info ml-2">
                      <div class="top">
                        <div class="title">
                          <h3>{{ item.company }}</h3>
                          <p class="ml-1">{{ item.name }}</p>
                        </div>
                        <p class="date">{{ item.date }}</p>
                      </div>
                      <div class="desc mt-1">
                        {{ item.desc }}
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <message></message>
  </div>
</template>

<script>
import { formatDate } from "@/assets/js/formDate.js";
import Banner from "@/components/common/banner";
import choose from "@/components/common/choose";
import passage from "@/components/common/passage";
import message from "@/components/common/message";
import connect from "@/components/common/connect";
import { WOW } from "wowjs";
export default {
  components: {
    Banner,
    passage,
    message,
    choose,
    connect,
  },
  data() {
    return {
      banners: {
        title: "12项施工总承包资质办理",
        desc: "快捷便利无忧 服务专业优质",
        list: [require("@/assets/image/banner/1.jpg")],
      },
      comments: [
        {
          icon: require("@/assets/image/contract/1.jpg"),
          name: " 王先生",
          company: "天津市***市政工程有限公司",
          desc: "提前两月拿到证书，进度及时汇报，不错",
          date: "2020-01-21",
        },
        {
          icon: require("@/assets/image/contract/2.jpg"),
          name: "陈先生",
          company: "北京市****（北京）科技有限公司",
          desc: "收费透明，不乱收费；申报人员问题反馈也很及时",
          date: "2020-05-23",
        },
        {
          icon: require("@/assets/image/contract/3.jpg"),
          name: "刘先生",
          company: "杭州市****劳务有限公司",
          desc: "6月找同行办理机电总包资质，8月份同行告知办不下来，经人介绍找到优普道，两个月就办理成功了。",
          date: "2020-06-07",
        },
        {
          icon: require("@/assets/image/contract/4.jpg"),
          name: "魏先生",
          company: "西安市**安建建筑工程有限公司",
          desc: "感觉挺不错的，全程都不用我们操心，一站式的代办，太省心了",
          date: "2020-03-18",
        },
        {
          icon: require("@/assets/image/contract/5.jpg"),
          name: "唐先生",
          company: "南昌市**电力工程建设有限公司",
          desc: "这家收费算比较符合行业标价，收费透明，效率也高，合作挺愉快的",
          date: "2020-4-23",
        },
        {
          icon: require("@/assets/image/contract/6.jpg"),
          name: "吴先生",
          company: "哈尔滨****建筑工程有限公司",
          desc: "多家对比后选择了优普道公司，专人定制的服务、实力雄厚的展现，办理速度提前下证，五星好评！",
          date: "2020-1-06",
        },
        {
          icon: require("@/assets/image/contract/7.jpg"),
          name: "王先生",
          company: "大庆市***建筑工程有限公司",
          desc: "办理过程很顺利，资质和安全生产许可证按期拿到。",
          date: "2020-07-13",
        },
        {
          icon: require("@/assets/image/contract/8.jpg"),
          name: "吴总",
          company: "海南**能源发展有限公司",
          desc: "给优普道点赞，办理效率很高，很有实力！",
          date: "2020-10-08",
        },
        {
          icon: require("@/assets/image/contract/9.jpg"),
          name: "吴先生",
          company: "广西峻宇建筑工程有限责任公司",
          desc: "办理资质这个公司比较靠谱。下证快，服务态度好。",
          date: "2020-11-11",
        },
        {
          icon: require("@/assets/image/contract/10.jpg"),
          name: "林先生",
          company: "福建**禾通信有限公司 ",
          desc: "多种办理方案供我选择，这服务没得说，建议我怎么办理的性价比最高，赞。",
          date: "2020-09-07",
        },
        {
          icon: require("@/assets/image/contract/11.jpg"),
          name: " 谢先生",
          company: "通**通信股份有限公司",
          desc: "办理人员专业，耐心，有不懂的地方给我说的明明白白，找对地方了",
          date: "2020-08-21",
        },
        {
          icon: require("@/assets/image/contract/12.jpg"),
          name: "李生",
          company: "茂名***建设工程有限公司",
          desc: "可以办理资质也可以找人才，不用自己到处找，大力推荐",
          date: "2020-09-06",
        },
        {
          icon: require("@/assets/image/contract/13.jpg"),
          name: "陈生",
          company: "广州**绿化工程有限公司",
          desc: "缺少的人才也是这补全的，完全没有延误办理周期",
          date: "2020-07-02",
        },
        {
          icon: require("@/assets/image/contract/14.jpg"),
          name: "简女士",
          company: "珠海**机械设施工程管理有限公司",
          desc: "办事效率高，办理的人员非常专业，申报前反复核对资料，确保我一次过，提前拿证",
          date: "2020-05-20",
        },
        {
          icon: require("@/assets/image/contract/15.jpg"),
          name: "吴生",
          company: "深圳**建设工程有限公司",
          desc: "办理顺利，一次通过，需要增项资质再合作！",
          date: "2020-01-21",
        },
        {
          icon: require("@/assets/image/contract/16.jpg"),
          name: "张生",
          company: "深圳**建筑设计工程有限公司",
          desc: "给优普道点个赞，办事效率高，员工专业服务好！",
          date: "2019-04-20",
        },
        {
          icon: require("@/assets/image/contract/17.jpg"),
          name: "王工",
          company: "广州**工程有限公司",
          desc: "服务到位，跟进及时，取证很顺利",
          date: "2019-05-18",
        },
        {
          icon: require("@/assets/image/contract/18.jpg"),
          name: "邓生",
          company: "佛山**星建设工程公司",
          desc: "报价合理透明，一对一服务跟进及时，拿证很顺利，很不错的一次合作",
          date: "2019-10-20",
        },
        {
          icon: require("@/assets/image/contract/19.jpg"),
          name: " 郑女士",
          company: "珠海**工程管理有限公司 ",
          desc: "5个资质一起办理，不到4个月便拿证了。 ",
          date: "2019-06-29",
        },
      ],
      questions: [],
      serverList: [
        {
          name: "建筑工程施工总承包",
          icon: require("@/assets/image/contract/37.png"),
        },
        {
          name: "铁路工程施工总承包",
          icon: require("@/assets/image/contract/38.png"),
        },
        {
          name: "公路工程施工总承包",
          icon: require("@/assets/image/contract/39.png"),
        },
        {
          name: "港口与航道工程施工总承包",
          icon: require("@/assets/image/contract/40.png"),
        },
        {
          name: "水利水电工程施工总承包",
          icon: require("@/assets/image/contract/41.png"),
        },
        {
          name: "电力工程施工总承包",
          icon: require("@/assets/image/contract/42.png"),
        },
        {
          name: "市政公用工程施工总承包",
          icon: require("@/assets/image/contract/43.png"),
        },
        {
          name: "通信工程施工总承包",
          icon: require("@/assets/image/contract/44.png"),
        },
        {
          name: "机电工程施工总承包",
          icon: require("@/assets/image/contract/45.png"),
        },
        {
          name: "矿山工程施工总承包",
          icon: require("@/assets/image/contract/46.png"),
        },
        {
          name: "石油化工工程施工总承包",
          icon: require("@/assets/image/contract/47.png"),
        },
        {
          name: "冶金工程施工总承包",
          icon: require("@/assets/image/contract/48.png"),
        },
      ],
      childList: [],
    };
  },
  methods: {
    // 获取常见问题
    getQuestionsList() {
      this.$api
        .getQuestionsList({ launchPage: 20, classify: 10, limit: 4 })
        .then((res) => {
          this.questions = res.data.list;
        });
    },
    getBannerList() {
      this.$api
        .getBannerList({
          // 10首页  20
          launchPage: 20,
          launchFacility: 10,
        })
        .then((res) => {
          this.banners.list = res.data.list;
        });
    },
    navView(url) {
      if (this.$ios) {
        window.location.href = url;
      } else {
        window.open(url);
      }
    },
    getCategoryChild() {
      this.$api
        .getCategoryChild({
          pid: 91,
        })
        .then((res) => {
          this.childList = res.data;
        });
    },
    initStrenghSwiper() {
      var strenghSwiper = new Swiper(".strength-container", {
        slidesPerView: "auto",
        spaceBetween: 20,
        loop: true,
        direction: "vertical",
        speed: 2000,
        autoplay: 1,
      });
    },
  },
  created() {
    this.comments.forEach((item, index) => {
      if (index < 6) {
        var rand = Math.floor(Math.random() * (30 - 0 + 1)) + 0; //0-30
        var randDate = new Date().getTime() - rand * 86400000;
        let c = formatDate(new Date(randDate), "yyyy-MM-dd");
        item.date = c;
      }
    });
    this.getQuestionsList();
    this.getBannerList();
  },
  mounted() {
    this.getCategoryChild();
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
    this.initStrenghSwiper();
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "HYYaKuHeiW";
  src: url(../../assets/font/HYYaKuHeiW.ttf);
  font-weight: normal;
  font-style: normal;
}

@import "@/assets/css/contract.scss";
</style>
